const ConfigUrls = {
  configMailPath: '/api/configuration/email',
}

const AuthUrls = {
  loginPath: '/api/auth/login',
  logoutPath: '/api/auth/logout',
  emailPassResetPath: '/api/auth/email-reset-pwd',
  resetPassword: '/api/auth/reset-password',
  checkToken: '/api/auth/password-reset',
}

const UserUrls = {
  listPath: '/api/users/',
  detailPath: '/api/users/',

  setPasswordPath: '/api/user/set-password',
  emailNotifications: '/api/users/email-notifications',
  updatePermissionsPath: '/api/user/update-permissions',
  totpConfigurationPath: '/api/user/totp-configuration',
}

const UserSettings = {
  departments: '/api/settings/departments/',
  employees: '/api/settings/employees/',
  company: '/api/settings/companies/',
  standardSetting: '/api/settings/standard-settings/',
  positionBillingRate: '/api/settings/billing-rates/',
  setPasswordPath: '/api/users/set-password',
}

const RoleUrls = {
  roles: '/api/settings/roles/',
  rights: '/api/settings/rights/',
}

const Projects = {
  projects: '/api/projects/',
  timeTrackingProjects: '/api/projects/time-tracking',
  customers: '/api/customers/',
  currentProjects: '/api/dashboard-current-projects',
  milestones: '/api/projects/milestones/'
}

const GlobalAccounting = {
  accountingExpenses: '/api/accounting/expenses/',
  accountingReceipts: '/api/accounting/receipts/',
  accountingInvoiceYears: '/api/accounting-invoice-years/',
}

const TimeTracking = {
  timeTracking: '/api/time-tracking/',
  activitiesTracking: '/api/tracking/activities/',
  currentTasksTracking: '/api/tracking/current-tasks/',
}

const GlobalDashboard = {
  tasksInProgress: '/api/tasks-in-progressed-on/',
  accountingOverview: '/api/dashboard-accounting-overview/',
  departmentOverview: '/api/dashboard-department-overview/',
}

const GlobalReport = {
  reports: '/api/reports/',
}

const Notification = {
  notification: '/api/notification/',
}

const Urls = {
  ConfigUrls,
  AuthUrls,
  UserUrls,
  UserSettings,
  Projects,
  TimeTracking,
  RoleUrls,
  GlobalAccounting,
  GlobalDashboard,
  GlobalReport,
  Notification,
}

export default Urls
